<template>
	<div class="row filter-buttons align-center">
		<div class="columns column12">
			<div class="flex-row gallery-nav">
				<div
					class="button-toggle"
					:class="{ active: filter === 'showAll' }"
					@click="$emit('change-filter', 'showAll')"
				>
					<span>{{ $t('showAll') }}</span>
				</div>
				<div
					v-for="item in items"
					:key="item"
					class="button-toggle"
					:class="{ active: filter === item }"
					@click="$emit('change-filter', item)"
				>
					<span>{{ item }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	filter: { type: String, default: 'showAll' },
});

defineEmits(['change-filter']);
</script>

<style lang="scss" scoped>
.gallery-nav {
	background: #fff;
	flex-wrap: wrap;
	justify-content: center;
	align-items: stretch;
	margin: 15px 0 30px;

	div {
		flex-grow: 1;
	}

	.button-toggle {
		padding: 25px;
		text-align: left;
		cursor: pointer;
		transition: all 0.3s ease-in-out;

		&.active,
		&:hover {
			background: $cta-color;
			color: #fff;
		}
	}
}

@media (max-width: 720px) {
	.gallery-nav {
		background: none;

		div {
			width: 48%;
			margin: 1%;
			background: #fff;
		}
	}
}
</style>
